import styled from 'styled-components'
import Link from 'next/link'
import { useProject } from 'querys/projects'
import { MdDone, MdClose } from 'react-icons/md'
import { Typography } from 'common/typography'

const ProjectChecksStyled = styled.ul`
  font-size: 18px;
  line-height: 32px;
  margin-block-start: 32px;
  margin-block-end: 16px;
  svg {
    flex-shrink: 0;
  }
  li {
    display: flex;
    gap: 8px;
  }
  .subscribe {
    color: var(--turquoise);
    text-decoration: underline;
  }
`

function ProjectChecks() {
  const { data: { type, has_full_access, is_free } } = useProject()
  const RESPONSIVE = 'RESPONSIVE'
  const MOBILE = 'MOBILE'
  const DESKTOP = 'DESKTOP'
  return (
    <ProjectChecksStyled>
      <Typography font="headline6">
        Contenido del Proyecto
      </Typography>
      {(type === MOBILE || type === RESPONSIVE) && (
        <li>
          <MdDone aria-hidden="true" className="close" size={30} color="#51A7B8" />
          Diseño Mobile
        </li>
      )}
      {(type === DESKTOP || type === RESPONSIVE) && (
        <li>
          <MdDone aria-hidden="true" className="close" size={30} color="#51A7B8" />
          Diseño Desktop
        </li>
      )}
      <li>
        <MdDone aria-hidden="true" className="close" size={30} color="#51A7B8" />
        Readme con la demo y descripción de proyecto
      </li>
      <li>
        <MdDone aria-hidden="true" className="close" size={30} color="#51A7B8" />
        HTML con muestras de color y fuentes
      </li>
      <li>
        {(has_full_access || is_free)
          ? <MdDone aria-hidden="true" className="close" size={30} color="#51A7B8" />
          : <MdClose aria-hidden="true" className="close" size={30} color="#F06D7E" />
        }
        <span>
          Diseño editable en Figma
          {
            (!has_full_access && !is_free) && (
              <>
                {': '}
                <Link href="/precios" className="subscribe">
                  Suscríbete
                </Link>
              </>
            )
          }
        </span>
      </li>
      <li>
        {(has_full_access || is_free)
          ? <MdDone aria-hidden="true" className="close" size={30} color="#51A7B8" />
          : <MdClose aria-hidden="true" className="close" size={30} color="#F06D7E" />
        }
        <span>
          Design System con componentes, colores, fuentes e iconografía
          {
            (!has_full_access && !is_free) && (
              <>
                {': '}
                <Link href="/precios" className="subscribe">
                  Suscríbete a proyectos
                </Link>
              </>
            )
          }
        </span>
      </li>
    </ProjectChecksStyled>
  )
}

export default ProjectChecks
